import { render } from "./AdminTechAlerts.vue?vue&type=template&id=45a0279e&scoped=true"
import script from "./AdminTechAlerts.vue?vue&type=script&lang=js"
export * from "./AdminTechAlerts.vue?vue&type=script&lang=js"

import "./AdminTechAlerts.vue?vue&type=style&index=0&id=45a0279e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a0279e"]])

export default __exports__